export const API_URL = `${process.env.PUBLIC_URL}/api/v1`;

export const axiosConfig = {
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
    },
}
